module.exports = __webpack_public_path__ + "img/shipping_type_4.0b178e8.webp";